<template>
  <div>
    <el-dialog title="签约" :visible.sync="dialogFormVisible" width="500px" center class="elform2"
    :close-on-click-modal="false" @close="closeDialog" @open="opendialog">
      <div v-loading="loading">
        <el-form :model="ruleForm" ref="ruleForm" label-width="140px" :center="true" class="demo-ruleForm" :rules="bankRules">
          <el-form-item label="签约银行" prop="bank">
            <el-select v-model="ruleForm.bank" placeholder="请选择" size="small" style="width: 300px;">
              <el-option v-for="(item,index) in banklist" :label="item.label" :value="item.value" key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="socialCreditCode">
            <el-input v-model="ruleForm.socialCreditCode" placeholder="请输入" size="small" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="开户名" prop="bankCardName">
            <el-input v-model="ruleForm.bankCardName" placeholder="请输入" size="small" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="银行账号" prop="bankCardNo">
            <el-input v-model="ruleForm.bankCardNo" placeholder="请输入账号"  size="small" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="预留手机号" prop="telNum">
            <el-input v-model="ruleForm.telNum" placeholder="请输入11位手机号" size="small" style="width: 300px;"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button style="width: 120px;background: #9B9B9B;border: none;" size="small" type="primary" @click="closeDialog">取 消</el-button>
          <el-button style="width: 120px;background: #269D7B;border: none;" size="small" type="primary" @click="confirm">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="线上签约"
      :visible.sync="iframedialog"
      center
      width="1400px"
      :close-on-click-modal="false"
      @close="closeiframe"
    >
    <span style='color: red;margin-bottom:10px;display: inline-block;font-size: 14px;font-weight: 600;'>请将下面链接复制到IE浏览器打开完成签约操作</span>
      <div v-if="!ifIE" class='url_container'>
        <span class='copyText' data-clipboard-action="copy">{{iframeurl}} </span>
        <el-button data-clipboard-action="copy" class="url_copy" :data-clipboard-text="iframeurl" @click="clickMeCopy"
          size='mini' plain round type='primary'
        >点我复制链接</el-button>
        <!-- <el-button size='mini' class='' type='primary' plain round @click="clickMeCopy">点我复制链接</el-button> -->
      </div>
      <iframe v-else :src="iframeurl" frameborder="0" width="100%" height="650px" scrolling="auto"></iframe>
    </el-dialog>
    <el-dialog title="" :visible.sync="dialogXieyi" width="500px" center :close-on-click-modal="false" :show-close='false'>
      <div class="">
        你有协议没有签约成功，是否继续
      </div>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button style="width: 120px;background: #9B9B9B;border: none;" size="small" type="primary" @click="cloaseme">取 消</el-button>
        <el-button style="width: 120px;background: #269D7B;border: none;" size="small" type="primary" @click="qianding">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import axios from 'Axios'
  import qs from 'qs'
  export default {
    props: ['visible'],
  	data(){
      var xydm = (rule, value, callback) => {
        let exp = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/;
        if (!exp.test(value)) {
          return callback(new Error('请输入正确的统一社会信用代码!'));
        }else{
          callback();
        }
      };
      var noHaz = (rule, value, callback) => {
        let exp = /^[A-Za-z0-9]+$/;
        if (!exp.test(value)) {
          return callback(new Error('只能是字母和数字组成!'));
        }else{
          callback();
        }
      };

      var phoneNumber = (rule, value, callback) => {
        let exp = /^1\d{10}$/;
        if(value != '' || value != null){
          if (!exp.test(value)) {
            return callback(new Error('请输入正确的联系电话!'));
          }else{
            callback();
          }
        }else{
          callback();
        }
      };
  		return {
        loading:false,
        dialogFormVisible:false,
        iframedialog:false,
        dialogXieyi:false,
        banklist:[],
        iframeurl:"",
        redata:'',
        ruleForm:{
          socialCreditCode:'',
          bankCardNo:'',
          bankCardName:'',
          bank:'',
          telNum:'',
        },
        bankRules:{
          socialCreditCode:[{required:true,message:'请输统一社会信用代码！'},{validator: xydm, trigger: 'blur'}],
          bankCardNo:[{required:true,message:'请输入银行账号！'},{validator: noHaz, trigger: 'blur'}],
          bankCardName:[{required:true,message:'请输入开户名！'}],
          bank:[{required:true,message:'请选择签约银行！'}],
          telNum:[{required:true,message:'请输入预留手机号！'},{validator: phoneNumber, trigger: 'blur'}]
        },
        ifIE:false,
  		}
  	},

  	computed: {

  	},
  	methods:{
      cloaseme(){
        this.dialogXieyi=false
        this.samefunctioin()
      },
      qianding(){
        this.dialogFormVisible=true
        this.dialogXieyi=false
        this.iframedialog=false
        this.$set(this.ruleForm,'socialCreditCode',this.redata.socialCreditCode)
        this.$set(this.ruleForm,'bankCardNo',this.redata.bankCardNo)
        this.$set(this.ruleForm,'bankCardName',this.redata.bankCardName)
        this.$set(this.ruleForm,'telNum',this.redata.telNum)
        this.banklist.forEach((item,index)=>{
          if(item.value==this.redata.bank){
            this.ruleForm.bank=item.value;
          }
        })
        this.samefunctioin()
      },
      samefunctioin(){
        this.$http.post('/bankContract/delContract',{bankNo:this.ruleForm.bankCardNo,socialCreditCode:this.ruleForm.socialCreditCode}).then((res)=>{
          if(res && res.data.code == '1'){
             // this.$message.success(res.data.msg)
          }
        })
      },
      closeDialog(){
        this.dialogFormVisible=false
        this.$emit('refresh',false)
      },
      closeiframe(){
        this.iframedialog=false
        // this.$http.post('/bankContract/queryContract',{bankNo:this.ruleForm.bankCardNo,socialCreditCode:this.ruleForm.socialCreditCode}).then((res)=>{
        //   if(res && res.data.code == '1'){
        //     let resdata=res.data.data
        //     this.redata=resdata[0].list[0]
        //     if(resdata&&resdata[0].isSucces){
        //       this.$emit('showpage',true)
        //     }else{
        //       this.$emit('showpage',false);
        //       this.dialogXieyi=true
        //     }
        //   }
        // })
      },
      navigatorforIE(){
        const _=this;
        var userAgent = navigator.userAgent;
        var isLessIE11 = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1;
        var isEdge = userAgent.indexOf('Edge') > -1 && !isLessIE11;
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
        if(isLessIE11){
            var IEReg = new RegExp('MSIE (\\d+\\.\\d+);');
            // 正则表达式匹配浏览器的userAgent字符串中MSIE后的数字部分，，这一步不可省略！！！
            IEReg.test(userAgent);
            // 取正则表达式中第一个小括号里匹配到的值
            var IEVersionNum = parseFloat(RegExp['$1']);
            if (IEVersionNum >= 9) {
              _.ifIE=true;
            }else{
              _.ifIE=false;
              _.$message.error('系统检测到您的浏览器为非IE浏览器，请复制链接到IE浏览器中进行签约!');
            }
        }else if(isEdge) {
          _.ifIE=true;
        } else if(isIE11) {
          _.ifIE=true;
        }else{
          //其他浏览器！
          _.ifIE=false;
          _.$message.error('系统检测到您的浏览器为非IE浏览器，请复制链接到IE浏览器中进行签约!');
        };

        console.log('是否是iE',_.ifIE)
      },
      opendialog(){
        this.loading=true
        this.$http.post('/sys/dict/list',{type:'bank'}).then((res)=>{
          this.loading=false
          if(res && res.data.code == '1'){
            this.banklist=res.data.data
          }
        })
      },

      //点我复制
      clickMeCopy() {
        let _this = this;
        let clipboard = new this.clipboard(".url_copy");
         clipboard.on('success', function () {
          _this.$message.success("您已复制成功！")
          clipboard.destroy();
         });
         clipboard.on('error', function () {
           _this.$message.error("复制失败！")
           clipboard.destroy();
         });

       },
      confirm(){
        this.$refs.ruleForm.validate(valid=>{
          if(valid){
           // this.navigatorforIE();
            this.loading=true
            this.$http.post('bankContract/contractV1',this.ruleForm).then(res=>{
                this.loading=false;
                if(res && res.data.code == '1'){
                  // let baseURL= "http://192.168.1.9:9003";
                  let baseURL= "https://mk.mankoo.cn";
                  this.dialogFormVisible=false;
                  this.iframedialog=true;
                  let datas = res.data.data;
                  this.iframeurl=baseURL+'?data=' + datas
                  // window.open(baseURL + "?data=" + datas)
                }
            }).catch(e=>{
              this.loading=false
            });
          }
        });

      }

  	},
    watch: {
  　　visible: {
　　　　handler(newValue, oldValue) {
          if(newValue.showdialog){
            this.dialogFormVisible=true;
            this.ruleForm = Object.assign(this.ruleForm,{
              socialCreditCode:'',
              bankCardNo:'',
              bankCardName:'',
              bank:'',
              telNum:'',
            });
          }
　　　　},
　　　　deep: true,
       immediate: true
  　　},

    }
  }
</script>

<style lang="less" scoped>
  .url_container {
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.3);
    padding: 30px 30px 50px;
    position: relative;
    .url_copy {
      position: absolute;
      bottom: 10px;
      right: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/bankwater/Signing.vue